import { render } from "./Rotate.vue?vue&type=template&id=512207f4"
import script from "./Rotate.vue?vue&type=script&lang=js"
export * from "./Rotate.vue?vue&type=script&lang=js"
script.render = render

export default script